const lang = {
    ja: {
        'adminSidebar.manageXPAND': '催し一覧管理',
        'adminSidebar.settingBooth': 'ブース情報設定',
        'adminSidebar.settingSeminarRoom': 'セミナー会議室設定',
        'adminSidebar.companyEventManagement': '出展企業一覧',
        'adminSidebar.organizerManagement': '出展申込管理',
        'adminSidebar.companyManagement': '企業基本情報',
        'adminSidebar.productExhibitionManagement': '展示商品情報',
        'adminSidebar.viewerManagement': '入場者申込管理',
        'adminSidebar.seminarManagement': 'セミナー情報',
        'adminSidebar.surveyManagement': 'アンケート管理',
        'adminSidebar.settingCustom': 'カスタム機能',
        'adminSidebar.settingMultiLanguage': '多言語機能',
        'adminSidebar.advertisementManagement': '広告管理',
        'adminSidebar.registSeminarManagement': 'セミナー受講申込管理',
        'adminSidebar.qaViewerManagement': '入場者向けよくあるご質問',
        'adminSidebar.qaViewerManagementEN': '入場者向けよくある質問（英語）',
        'adminSidebar.qaManagement': 'よくある質問管理',
        'adminSidebar.qaOrganizerManagement': '出展者向けよくあるご質問',
        'adminSidebar.qaOrganizerManagementEN': '出展者向けよくある質問（英語）',
        'adminSidebar.visitHistory': '閲覧履歴',
        'adminSidebar.allSeminar': 'セミナーの一覧',
        'adminSidebar.liveStreamManagement': 'ライブ配信イベント一覧',
        'adminSidebar.outerServerMail': '外部サーバー専用メール自動送信設定',
        'adminSidebar.settingShoppingCart': 'ショッピングカート設定',
        'adminSidebar.orderProductPaymentManagement': '注文商品支払い管理',
        'adminSidebar.registerLivestreamManagement': 'ライブ配信申込管理',
        'adminSidebar.settingProductCompany': '商品販売設定',
        'adminSidebar.editEventDialog': '催し内容を変更',
    },
};

export default lang;
